/**
 * Feature Domain Types
 *
 * Architecture: Clean Architecture - Domain Layer
 * Features isolate BM data per task/feature.
 */

// ============================================================================
// Identifiers (Value Objects)
// ============================================================================

export type TFeatureId = string & { readonly __brand: "FeatureId" };

export function createFeatureId(value: string | number): TFeatureId {
  return String(value) as TFeatureId;
}

// ============================================================================
// Feature Status
// ============================================================================

export type FeatureStatus =
  | "draft"
  | "in_progress"
  | "review"
  | "merged"
  | "archived";

export const FEATURE_STATUSES: readonly FeatureStatus[] = [
  "draft",
  "in_progress",
  "review",
  "merged",
  "archived",
] as const;

// ============================================================================
// Feature Entity
// ============================================================================

export interface IFeature {
  readonly id: TFeatureId;
  readonly projectId: string;
  readonly parentFeatureId?: TFeatureId;
  readonly name: string;
  readonly description?: string;
  readonly status: FeatureStatus;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly isDeleted: boolean;
  readonly deletedAt?: string;
  readonly lastSeenAt: string;
}

// ============================================================================
// Request DTOs
// ============================================================================

export interface ICreateFeatureRequest {
  readonly name: string;
  readonly description?: string;
  readonly status?: FeatureStatus;
}

export interface IUpdateFeatureRequest {
  readonly name?: string;
  /** `null` — очистить описание; поля нет — не менять (feature-lifecycle-R07). */
  readonly description?: string | null;
  readonly status?: FeatureStatus;
}
